export default {
    cancelButton: {
        name: 'Отменить',
        modalText: 'Подтвердите отмену заказа и укажите причину',
        buttonCancel: 'Вернуться к заказу',
        buttonSend: 'Подтверждаю',
        message: 'Не удалось выполнить действие',
        emptyReasonText: 'Данный заказ будет отменен без указания причины. Вы уверены?',
        noReasonsError: 'Не удалось получить список причин отмены заказа',
    },

    refundButton: {
        modalText: 'Вы действительно хотите инициировать возврат ДС',
        buttonCancel: 'Вернуться к заказу',
        buttonSend: 'Подтверждаю',
        message: 'Не удалось выполнить действие',
    },

    editAfter: {
        name: 'Редактировать заказ',
        message: 'Не удалось поменять статус заказа № {orderId}, обратитесь в поддержку CRM',
    },

    issueOrder: {
        title: 'Проверить код и выдать заказ',
        name: 'Выдать заказ',
        modalTitle: 'Проверка кода выдачи заказа',
        modalText: 'Код выдачи:',
        buttonCheck: 'Проверить',
        buttonCancel: 'Отмена',
        // eslint-disable-next-line max-len
        messageCheckAttempts: "Код выдачи был введен неверно 5 раз. Вам нужно срочно создать заявку по ошибке в Поддержка CRM <a href='mailto:_support_CRM@fix-price.ru'>_support_CRM@fix-price.ru</a>",
        messageCode: 'Нужно ввести код выдачи',
        messageError: 'Не удалось проверить код выдачи',
        placeholder: 'Введите код из смс',
        communication: 'Введите четырехзначный код из смс, который вам должен сообщить покупатель',
        appMobileTitle: 'Печать АПП',
        appMobileBody: 'Необходимо распечатать АПП и отдать документ клиенту. Для печати АПП перейдите на стационарный ПК.',
        appMobileOk: 'Хорошо',
    },
    logButton: 'Лог заказа',
    returnFrom: 'Возврат из доставки',

    sendCode: {
        name: 'Отправить повторно SMS с кодом',
        text: 'Получить новый код',
        messageConfirmation: 'Не удалось получить начальную информацию',
        messageInfo: 'Не удалось отправить код',
    },

    issue: {
        title: 'Выдача заказа без подтверждения',
        name: 'Выдать заказ',
        message: 'Вы подтверждаете, что заказ оплачен и выдан клиенту?',
    },

    timeIncreased: {
        title: 'Отправить уведомление об увеличении срока сборки заказа',
        name: 'Срок сборки увеличен',
        message: 'Вы уверены, что хотите отправить клиенту уведомление об увеличении срока сборки заказа?',
    },

    issueToCourier: {
        buttonTitle: 'Выдать курьеру',
        modalTitle: 'Внимание!',
        modalText: 'Вы подтверждаете передачу заказа курьеру?',
        modalOk: 'Подтверждаю',
        modalCancel: 'Отмена',
    },

    submit: {
        apply: 'Применить',
        reset: 'Сбросить',
    },

    reloadLabel: {
        okTitle: 'Да',
        message: 'Вы действительно хотите перезапросить этикетку?',
        labelRequest: 'Запрос этикетки',
        success: 'Этикетка сформирована!',
        error: 'Не удалось сформировать этикетку!',
        reRequest: 'Перезапросить этикетку',
        close: 'Закрыть',
    },
};